import { FavoriteTabNames } from './FavoriteTabNames'

import { SectionListItem, getSectionListSortedByNormalizedName } from 'Components'
import { NormalizedName, addNormalizedNameProp } from 'Components/SectionList/sortItemList'
import { FavoritesFood, FavoritesMotionLevel, FavoritesRecipe } from 'Models'

export const getFavoriteEatableName = (item: FavoritesFood | FavoritesRecipe): string =>
  'recipe' in item ? item.recipe.name : item.food.name

export const getFavoriteMotionName = (item: FavoritesMotionLevel): string => item.motionLevel.motion.name

const favoriteEatablesWithNormalizedName = (
  favoriteEatables: (FavoritesFood | FavoritesRecipe)[]
): ((FavoritesFood | FavoritesRecipe) & NormalizedName)[] =>
  favoriteEatables.map((favorite) => addNormalizedNameProp(favorite, getFavoriteEatableName(favorite)))

type GetFavoriteEatableSectionListArgs = {
  key: string
  favoriteSystemFoods: FavoritesFood[]
  favoriteSystemRecipes: FavoritesRecipe[]
  favoriteUserEatables: (FavoritesFood | FavoritesRecipe)[]
}

export const getFavoriteEatablesSectionList = ({
  key,
  favoriteSystemFoods,
  favoriteSystemRecipes,
  favoriteUserEatables
}: GetFavoriteEatableSectionListArgs): SectionListItem<(FavoritesFood | FavoritesRecipe) & NormalizedName>[] => {
  const favoriteEatables =
    key === FavoriteTabNames.FOODS
      ? favoriteSystemFoods
      : key === FavoriteTabNames.RECIPES
      ? favoriteSystemRecipes
      : favoriteUserEatables

  return getSectionListSortedByNormalizedName(favoriteEatablesWithNormalizedName(favoriteEatables))
}

export const getFavoriteMotionsSectionList = (
  favoritesMotionLevels: FavoritesMotionLevel[]
): SectionListItem<FavoritesMotionLevel & NormalizedName>[] =>
  getSectionListSortedByNormalizedName(
    favoritesMotionLevels.map((favorite) => addNormalizedNameProp(favorite, getFavoriteMotionName(favorite)))
  )
